// Talep belge kuralları ve şartları (sistemde tanımlı kuralların sade özeti)
export const DOC_RULE_SECTIONS = [
  {
    title: '1. Firma Evrakları',
    items: [
      'SGK Hizmet Listesi: tarihli belgedir; firma sicil numarasının son 4 hanesi girilir (4 rakam olmalı). Listede adı olan personeller talepte işaretlenir.',
      'İSG Katip Uzman ve İSG Katip Hekim sözleşmeleri: firmanın İSG profesyonellerini gösterir; uzman/hekim adı ve sicil son 4 hanesi kaydedilir.',
      'Firma profil belgeleri: Vergi Levhası, KVKK Taahhütnamesi, Üst İşveren Vekili. Yeni KVKK sürümü yayınlanırsa firma yükleyene kadar yeni talep oluşturamaz.',
      'Hangi firma evrakının zorunlu / opsiyonel olduğu Çalışma Alanı tanımındaki belge listesinden otomatik belirlenir.',
    ],
  },
  {
    title: '2. Personel Evrakları',
    items: [
      'SGK İşe Giriş (tarihli), İSG Eğitimi (geçerlilikli), Sağlık Raporu (geçerlilikli), Mesleki Yeterlilik / MYK (geçerlilikli), Mesleki Eğitim, KKD Zimmet.',
      'Zorunlu personel evrakları Çalışma Alanı tanımından gelir; tanım yoksa tüm personel evrakları istenir.',
      'Talepte en az bir personel olmalıdır. Bloklu (T.C. bazlı) personel hiçbir firmada talebe eklenemez.',
      '"Kapsam Dışı" işaretlenen belge o talep için istenmez; talep sonuçlanınca işaret kalkar, sonraki talepte yeniden değerlendirilir.',
      'Personel bilgileri talep anındaki haliyle mühürlenir (sonradan yapılan değişiklik eski talebi etkilemez).',
    ],
  },
  {
    title: '3. Tehlike Sınıfına Göre Geçerlilik Süreleri',
    table: [
      ['Tehlike Sınıfı', 'İSG Eğitimi', 'Sağlık Raporu'],
      ['Az Tehlikeli', '3 yıl', '5 yıl'],
      ['Tehlikeli', '2 yıl', '3 yıl'],
      ['Çok Tehlikeli', '1 yıl', '1 yıl'],
    ],
    items: [
      'İSG uzmanı onaylamadan önce Bölüm 2\'de firmanın tehlike sınıfını seçmek zorundadır.',
      'İSG Eğitimi, Sağlık Raporu ve MYK geçerlilik tarihi talep bitiş tarihinden önce doluyorsa uyarı verilir ve en güvenli tarih önerilir.',
    ],
  },
  {
    title: '4. Belgeler Arası Bağlantılar (Altın Kural)',
    intro: 'Kaynak belge değişirse (yeniden yükleme, silme, eksik işaretleme, süre dolumu) ona bağlı belgeler talepte otomatik olarak "Onay Bekliyor" durumuna düşer. Bu bir hata değildir; yeniden kontrol gerektiği içindir.',
    table: [
      ['Değişen Belge', 'Otomatik "Onay Bekliyor"a Düşenler'],
      ['SGK Hizmet Listesi (firma)', 'İSG Katip Uzman, İSG Katip Hekim + personelin SGK İşe Giriş, İSG Eğitimi, Sağlık Raporu'],
      ['İSG Katip Uzman (firma)', 'Personelin İSG Eğitimi'],
      ['İSG Katip Hekim (firma)', 'Personelin İSG Eğitimi ve Sağlık Raporu'],
      ['SGK İşe Giriş (personel)', 'Aynı personelin İSG Eğitimi ve Sağlık Raporu'],
    ],
    items: [
      'İstisna: SGK Hizmet Listesi aynı sicil numarasıyla yeniden onaylanırsa ve personelin İşe Giriş / Katip sözleşmelerindeki sicil aynıysa bağlı belgeler tekrar onaya düşmez.',
      'Personel SGK Hizmet Listesi\'nden çıkarılırsa SGK İşe Giriş belgesi yeniden onaya düşer.',
      'Bağlı belgesi olan bir belge silinirken firmaya uyarı gösterilir.',
    ],
  },
  {
    title: '5. SGK Hizmet Listesi Personel Teyidi',
    items: [
      'Yeşil tik: personel listede var veya yeni giriş yapmış.',
      'Kırmızı çarpı: personel listede yok (veya SGK İşe Giriş onaylı değil).',
      'Sarı ünlem: İşe giriş tarihi liste tarihinden 1 ay veya daha eskiyse ve personel listede yoksa "SGK\'si olmayabilir" uyarısı verilir; uzman uyarıya rağmen onaylayabilir.',
    ],
  },
  {
    title: '6. İş Ekipmanı Evrakları',
    items: [
      'Periyodik Muayene (geçerlilik tarihli) ve ekipman türüne göre tanımlı diğer belgeler (ör. Operatörlük Belgesi).',
      'Periyodik muayene tarihi girilmemişse veya talep bitişinden önce doluyorsa ekipman geçersiz sayılır.',
    ],
  },
  {
    title: '7. Süresi Dolan Belgeler',
    items: [
      'Geçerlilik tarihi geçen onaylı belgenin dosyası otomatik kaldırılır, durumu "Eksik" olur ve "Süresi geçtiği için silindi (tarih)" notu düşülür. Eski dosya geçmişte saklanır.',
      'Bu işlem bağlı belgeleri de tetikler (bkz. Madde 4).',
      'Her gün 07:00\'de belge geçerlilik hatırlatma e-postaları gönderilir.',
    ],
  },
  {
    title: '8. Onay / Red Yetkisi ve Talep Akışı',
    items: [
      'Belge onay / red kararını yalnızca yetkili lokasyondaki İSG Uzmanı veya Süper Admin verir; firma belgeyi sadece "Beklemede" olarak yükleyebilir.',
      'Önizlemede açılmayan belge onaylanamaz. Red açıklaması zorunludur.',
      'Akış: Taslak → İSG İncelemesinde → (Eksik/Hatalı | Talep Bilgisi Hatalı) → Onay Bekliyor (2. Onaycı) → Onaylandı.',
      'Talep Bilgisi Hatalı durumunda firma İSG\'nin önerdiği bilgileri girmeden tekrar gönderemez.',
      'İSG kontrol ederken firma talebi geri çekemez. Taslak talebi yalnızca oluşturan kişi silebilir.',
      'Sonuçlanan talebin belgeleri o anki haliyle dondurulur (snapshot); sonradan yapılan değişiklik eski talebi etkilemez.',
    ],
  },
  {
    title: '9. Gönderim Öncesi Engeller',
    items: [
      'Lokasyonun İSG taahhütnamesi onaylanmadan talep gönderilemez.',
      'Yasaklı zaman kuralına denk gelen talep gönderilemez; en yakın uygun zaman önerilir.',
      '"Okudum, anladım" onayı bekleyen duyuru varsa ve engelleme açıksa talep gönderilemez.',
      'Pasif firma talep oluşturamaz; mağaza seçimi zorunlu alanlarda mağaza seçilmeden gönderilemez.',
    ],
  },
];
